import { FilterField, FilterFieldOption } from "~/features/filter";
import { useGetPositionsOptions } from "~/pages/StaffEmployeePersonal/hook/useGetPositionsOptions";
import { ISelectOption } from "~/shared/ui/Fields/types";

/**
 * Значение фильтра должностей: массив id выбранных должностей
 * (в URL сериализуется строкой через запятую — см. features/filter serialize).
 */
export type TEducationalProgramsManagementFilter = {
  positions: string[];
};

type Translate = (key: string) => string;

interface IGetFilterFieldsProps {
  t: Translate;
  positionsSelectOptionsList: ISelectOption[];
  positionsSelectMethods: ReturnType<typeof useGetPositionsOptions>;
}

/**
 * Поля фильтра страницы управления учебной программой:
 * мультиселект должностей с серверным поиском и догрузкой по скроллу.
 * Значения подставляются из данных программы (ids в URL) и не редактируются —
 * поле задизейблено, фильтр на странице не функционирует.
 */
export const getFilterFields = ({
  t,
  positionsSelectOptionsList,
  positionsSelectMethods,
}: IGetFilterFieldsProps): FilterField[] => [
  {
    name: "positions",
    type: "select",
    multiple: true,
    disabled: true,
    // Показываем все подставленные должности: селект растягивается вниз,
    // без схлопывания лишних тегов в «+ N»
    maxTagCount: null,
    label: t("patp.position"),
    optionsHook: () => ({
      // positionToSelectOption всегда заполняет label и value,
      // но ISelectOption декларирует их опциональными
      options: positionsSelectOptionsList as FilterFieldOption[],
      loading: positionsSelectMethods.loading,
      onScrollBottom: positionsSelectMethods.onScrollBottom,
      searchOptions: positionsSelectMethods.searchText,
    }),
  },
];
